import { Route, Routes } from 'react-router-dom';
import { AdminCheck } from './components/AdminCheck';
import { AuthCheck } from './components/AuthCheck';
import { AdminApplications } from './components/admin/application/Applications';
import { ApplicationEdit } from './components/admin/application/ApplicationEdit';
import { ApplicationForm } from './components/admin/application/ApplicationForm';
import { AdminConfigs } from './components/admin/config/Configs';
import { ConfigEdit } from './components/admin/config/ConfigEdit';
import { ConfigForm } from './components/admin/config/ConfigForm';
import { AdminMaxLocations } from './components/admin/max-location/MaxLocations';
import { MaxLocationEdit } from './components/admin/max-location/MaxLocationEdit';
import { MaxLocationForm } from './components/admin/max-location/MaxLocationForm';
import { AdminMaxSummaries } from './components/admin/max-summary/MaxSummaries';
import { AdminStations } from './components/admin/station/Stations';
import { AdminStationForm } from './components/admin/station/StationForm';
import { AdminStationEdit } from './components/admin/station/StationEdit';
import { AdminUsers } from './components/admin/user/Users';
import { UserEdit } from './components/admin/user/UserEdit';
import { UserForm } from './components/admin/user/UserForm';
import { Advisory } from './components/advisory/Advisory';
import { Login } from './components/Login';
import { Observations } from './components/observations/Observations';
import { AlertsList } from './components/alerts/AlertsList';
import { AlertsEdit } from './components/alerts/AlertsEdit';
import { AlertForm } from './components/alerts/AlertsForm';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<AuthCheck />}>
                <Route path="" element={<Observations />} />
                <Route path="alerts" element={<AlertsList />} />
                <Route path="alerts/:id" element={<AlertsEdit />} />
                <Route path="alerts/create" element={<AlertForm />} />
                <Route path="advisory" element={<Advisory />} />
                <Route path="settings" element={<div>settings</div>} />
                <Route path="admin" element={<AdminCheck />}>
                    <Route path="stations" element={<AdminStations />} />
                    <Route path="stations/:id" element={<AdminStationEdit />} />
                    <Route path="stations/create" element={<AdminStationForm />} />
                    <Route path="users" element={<AdminUsers />} />
                    <Route path="users/:id" element={<UserEdit />} />
                    <Route path="users/create" element={<UserForm />} />
                    <Route path="applications" element={<AdminApplications />} />
                    <Route path="applications/:id" element={<ApplicationEdit />} />
                    <Route path="applications/create" element={<ApplicationForm />} />
                    <Route path="max-locations" element={<AdminMaxLocations />} />
                    <Route path="max-locations/:id" element={<MaxLocationEdit />} />
                    <Route path="max-locations/create" element={<MaxLocationForm />} />
                    <Route path="max-summaries" element={<AdminMaxSummaries />} />
                    <Route path="configs" element={<AdminConfigs />} />
                    <Route path="configs/:id" element={<ConfigEdit />} />
                    <Route path="configs/create" element={<ConfigForm />} />
                </Route>
            </Route>
        </Routes>
    );
};
